// Tela de login do usuário.
// Usa useJwtAuth para chamar signIn.


import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { text } from '../text';
import { hooks } from '../hooks';
import { utils } from '../utils';
import { custom } from '../custom';
import { svg } from '../assets/svg';
import { theme } from '../constants';
import { components } from '../components';
import { Mail, Key, Eye, EyeOff } from 'lucide-react';
import Https from '../utils/apiUtility';

import useJwtAuth from '../auth/services/jwt/useJwtAuth'; 
import axios from 'axios';


const API_URL = "http://localhost:3000";
interface SubscriberType {
  email: string;
}

export const SignIn: React.FC = () => {
  const { pathname } = useLocation();
  const location = useLocation();
  const navigate = hooks.useAppNavigate();
  const { signIn } = useJwtAuth(); 

  const [rememberMe, setRememberMe] = useState(false);
  const [subscriber, setSubscriber] = useState<SubscriberType | null>(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null); 
  const [showPassword, setShowPassword] = useState(false);


  useEffect(() => {
    setTimeout(() => {
      window.scroll({ top: -1, left: 0, behavior: 'smooth' });
    }, 10);
  }, [pathname]);

  useEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (location.pathname.includes('Onboarding')) {
      metaThemeColor?.setAttribute('content', '#040325');
    } else {
      metaThemeColor?.setAttribute('content', '#ffffff');
    }
  }, [location]);

  useEffect(() => {
    const fetchSubscriber = async () => {
      try {
        const response = await Https.get('/assinante');
        setSubscriber(response.data);
      } catch (error) {
        console.error('Erro ao buscar assinante:', error);
      }
    };

    fetchSubscriber();
  }, []);


  const handleLogin = async () => {
    if (!email.trim()) {
      setErrorMessage('Preencha o campo de e-mail!');
      return;
    }
  
    try {
      setErrorMessage(null);
  
      // 🛠️ Debug - Log antes da requisição
      console.log('Solicitando OTP para:', email);

      const response = await axios.post(`${API_URL}/auth/request-otp`, {
        identifier: email,
        type: 'email'
      });

      // const response = await axios.post('http://localhost:3000/auth/request-otp', {
      //   identifier: email,
      //   type: 'email'
      // });

  
      // 🛠️ Debug - Log da resposta completa
      console.log('Resposta completa:', response);
  
      if (response.status === 201) { 
        localStorage.setItem('user_email', email);
        navigate('/ConfirmationCode', { state: { email } });
      } else {
        setErrorMessage(`Erro ao solicitar código OTP: ${response.status}`);
      }
    } catch (error: any) {
      // 🛠️ Debug - Log do erro completo
      console.error('Erro na requisição OTP:', error);
  
      // Verifica se é um erro de resposta do Axios
      if (error.response) {
        console.error('Erro da API:', error.response);
        setErrorMessage(`Erro ao solicitar código OTP: ${error.response.status}`);
      } else if (error.request) {
        console.error('Erro de rede:', error.request);
        setErrorMessage('Erro de conexão com o servidor.');
      } else {
        console.error('Erro inesperado:', error.message);
        setErrorMessage('Erro inesperado ao solicitar código OTP.');
      }
    }
  };
  
  
  
 

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const renderHeader = (): JSX.Element => {
    return <components.Header />;
  };

  const renderContent = (): JSX.Element => {
    return (
      <main
        className="container"
        style={{ marginTop: 52, paddingTop: '18%', paddingBottom: 20, zIndex: 1 }}
      >
        <text.H1 style={{ marginBottom: 30 }}>Bem vindo de volta!</text.H1>

        {/* Campo de Email */}
        <custom.InputField
          leftIcon={
            <div
              style={{
                padding: 8,
                backgroundColor: theme.colors.lightGrey,
                borderRadius: '20%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                
              }}
            >
              <Mail size={18} color={theme.colors.mainDark} />
            </div>
          }
          containerStyle={{ marginBottom: 30 }}
          placeholder="Digite seu e-mail"
          value={email}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
        />


        {/* Campo de Senha */}
        {/* <custom.InputField
          placeholder="••••••••"
          clickable={true}
          leftIcon={
            <div
              style={{
                padding: 8,
                backgroundColor: theme.colors.lightGrey,
                borderRadius: '20%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Key size={18} color={theme.colors.mainDark} />
            </div>
          }
          rightIcon={
            <div onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }}>
              {showPassword ? <Eye size={18} color={theme.colors.mainDark} /> : <EyeOff size={18} color={theme.colors.mainDark} />}
            </div>
          } 
          containerStyle={{ marginBottom: 14 }}
          value={password}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
          type={showPassword ? 'text' : 'password'} 
        /> */}


        {/* Exibe erro caso as credenciais estejam erradas */}
        {errorMessage && <p style={{ color: 'red', marginBottom: 10 }}>{errorMessage}</p>}

        {/* Remember me */}
        {/* <div style={{ ...utils.rowCenterSpcBtw(), marginBottom: 30 }}>
          <button
            style={{
              cursor: 'pointer',
              ...utils.rowCenterSpcBtw(),
            }}
            onClick={() => setRememberMe(!rememberMe)}
          >
            <div
              style={{
                width: 18,
                height: 18,
                borderRadius: 4,
                ...utils.flexCenter(),
                border: `1px solid ${theme.colors.mainColor}`,
              }}
            >
              {rememberMe && <svg.InputCheckSvg />}
            </div>
            <text.T16 style={{ marginLeft: 12 }}>Lembre de mim</text.T16>
          </button> */}
          {/* Esqueci a senha */}
          {/* <text.T16
            onClick={() => navigate('/ForgotPassword')}
            style={{ cursor: 'pointer', color: theme.colors.mainColor }}
          >
            Perdeu sua senha?
          </text.T16>
        </div> */}

        {/* Botão de Login */}
        <components.Button
          title="Entrar"
          containerStyle={{ marginBottom: 14 }}
          onClick={handleLogin}
        />

        {/* <div style={{ ...utils.rowCenter(), marginBottom: 40 }}>
          <text.T16 style={{ marginRight: 4 }}>Ainda não tem uma conta?</text.T16>
          <text.T16
            onClick={() => navigate('/ConfirmationCode')}
            style={{ cursor: 'pointer', color: theme.colors.mainColor }}
          >
            Cadastre-se agora
          </text.T16>
        </div> */}
      </main>
    );
  };

  return (
    <div id="screen">
      {renderHeader()}
      {renderContent()}
    </div>
  );
};
